import React, { useState } from "react";
import styles from "./Navbar2.module.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import Box from "@mui/material/Box";
import { IconContext } from "react-icons/lib";
import IconButton from "@mui/material/IconButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuItem from "@mui/material/MenuItem";
import { Avatar, Divider, ListItemIcon, Tooltip } from "@mui/material";
import Menu from "@mui/material/Menu";
import { Logout, Settings } from "@mui/icons-material";
import PasswordChangeModal from "./PassowrdChangeModal";

const Navbar2 = () => {
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const isMenuOpen = Boolean(anchorEl);
  // const menuId = "primary-search-account-menu";
  // const handleProfileMenuOpen = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  //   // handleMobileMenuClose();
  // };
  // const renderMenu = (
  //   <Menu
  //     sx={{ top: "40px", left: "20px" }}
  //     anchorEl={anchorEl}
  //     anchorOrigin={{
  //       vertical: "top",
  //       horizontal: "right",
  //     }}
  //     id={menuId}
  //     keepMounted
  //     transformOrigin={{
  //       vertical: "top",
  //       horizontal: "right",
  //     }}
  //     open={isMenuOpen}
  //     onClose={handleMenuClose}
  //   >
  //     <MenuItem onClick={handleMenuClose}>Password Change</MenuItem>
  //     <MenuItem
  //       onClick={() => {
  //         handleMenuClose();
  //         Logout();
  //       }}
  //     >
  //       Logout
  //     </MenuItem>
  //   </Menu>
  // );
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logoutHandler = () => {
    localStorage.removeItem("status");
    window.location.reload();
  };
  return (
    <IconContext.Provider value={{ color: "#FFF" }}>
      <div className={styles.container}>
        <div className={styles.main}>
          <div className={styles.container_wrap}>
            <ul className={styles["header_noti_icons"]}>
              <li>
                <Tooltip title="Profile">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    <Avatar sx={{ width: 32, height: 32 }}></Avatar>
                  </IconButton>
                </Tooltip>
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleClose}
                  // onClick={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  {/* <MenuItem>
                    <ListItemIcon>
                      <Settings fontSize="small" />
                    </ListItemIcon>
                    Password Change
                  </MenuItem> */}
                  <PasswordChangeModal />
                  <MenuItem onClick={logoutHandler}>
                    <ListItemIcon>
                      <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                  </MenuItem>
                </Menu>
              </li>
            </ul>
            {/* <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <IconButton
            size="large"
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
        </Box>
        {renderMenu} */}
            {/* {renderMenu} */}
            {/* <LogoutIcon
          sx={{ fill: "#fff", fontSize: "25px", marginRight: "7px" }}
        />
        Logout */}
          </div>
        </div>
        {/* <div className={styles.box}>
        <div>Logout</div>
      </div> */}
      </div>
    </IconContext.Provider>
  );
};

export default Navbar2;
